import { Div, Image, Collection, Span, TableBuilder, Link, Line } from "@tblabs/truffle";
import { Notification } from "../../Components/Notification";
import { ShopContentProvider } from "../../Services/Content/ShopContentProvider";
import { DangerButton } from "../../Components/Utils/DangerButton";
import { Product } from "../../Models/Product/Product";
import { ProductCategory } from "../../Models/Product/ProductCategory";
import { Page } from "../Product/Page";


export class ProductCategoryEditPage extends Page
{
    constructor(
        private _shop: ShopContentProvider,
        private categoryUrl: string)
    {
        super("specTeam.pl - Zarządzanie kolejnością produktów w kategorii", "admin-page");

        this.Content(async (body) =>
        {
            await this._shop.Load();

            const shop = this._shop.Shop;

            const categories: Collection<ProductCategory> = shop.ProductCategories;
            const categoryId = categories.Items.find(x => x.Url.value == this.categoryUrl)?.Id?.value;
            const categoryTitle = categories.Items.find(x => x.Url.value == this.categoryUrl)?.Title?.value;
            const productsInCategory = new Collection(shop.Products.Items.filter(x => x.Category.Id.value == categoryId));
            const otherProducts: Product[] = shop.Products.Items.filter(x => x.CategoryId.value != categoryId);

            body.Append(
                "Zarządzanie kolejnością produktów w kategorii ", new Span(categoryTitle ?? "(kategoria bez nazwy)").Bold(),
                new TableBuilder(productsInCategory)
                    .AddColumn("", product => product.Images.Items?.[0]?.MiniUrl
                        ? new Image(product.Images.Items[0]?.MiniUrl).Height(32).DisplayInlineBlock().MarginRight(8).BorderRadius(4)
                        : new Div().Height(32).DisplayInlineBlock().MarginRight(8).BorderRadius(4).Text("no pic").Background("#888").FontSize(10).Width(48).TextAlignCenter())
                    .AddColumn("", product => new Link(product.Title.value).OnClick(() => window.location.hash = `product/edit/${product.Url.value}`).FontSize(12))
                    .AddColumn("", product => new Span(product.Visible.value ? "widoczny" : "ukryty").Class("badge"))
                    .AddColumn("", product => [
                        productsInCategory.CanSwapUp(product) && new Link("⬆️").OnClick(() => productsInCategory.SwapUp(product)),
                        productsInCategory.CanSwapDown(product) && new Link("⬇️").OnClick(() => productsInCategory.SwapDown(product)),
                    ])
                    .Build(),
                new Line().Margin(32),
                new DangerButton("Zapisz zmiany")
                    .OnClick(async () =>
                    {
                        const allProductsAfterOrderChanges = [...productsInCategory.Items, ...otherProducts];
                        shop.Products.Load(...allProductsAfterOrderChanges);
                        console.table(shop.Products.Items.map(x => x.Title.value + " @ " + x.Category.Title.value));
                        await this.SaveChanges();
                    })
            );
        });
    }

    private async SaveChanges(): Promise<void>
    {
        const result = await this._shop.SaveChanges();

        new Notification(result.IsSuccess ? "✅ Zmiany zapisane" : "❌ Problem z zapisaniem zmian", result.ErrorMessage || (result.ContentSize.toFixed(2) + "kb"));
        window.location.hash = `/`;
    }
}
